/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Boundary } from '@floating-ui/react';

import { breakpoints } from '@coursera/cds-core';

import SettingsMenuButton from 'bundles/video-player/components/settingsMenu/SettingsMenuButton';

const styles = {
  settingsMenu: css`
    height: 100%;
    position: relative;
    color: #dedede;

    ${breakpoints.down('xs')} {
      height: 30px;
      display: flex;
      align-items: center;
    }
  `,
  modernSettingsMenu: css`
    margin-right: var(--cds-spacing-200);
  `,
};

type Props = {
  onSettingsMenuClick: () => void;
  menuPopupVisible: boolean;
  buttonRef?: React.Ref<HTMLButtonElement>;
  videoBoundaryElement?: Boundary;
};

const VideoSettingsMenu = React.forwardRef(
  (
    { onSettingsMenuClick, menuPopupVisible, buttonRef, videoBoundaryElement }: Props,
    ref: React.Ref<HTMLDivElement>
  ) => {
    return (
      <div css={[styles.settingsMenu, styles.modernSettingsMenu]} ref={ref} className="rc-VideoSettingsMenu">
        <SettingsMenuButton
          menuPopupVisible={menuPopupVisible}
          onClick={onSettingsMenuClick}
          ref={buttonRef}
          videoBoundaryElement={videoBoundaryElement}
        />
      </div>
    );
  }
);

export default VideoSettingsMenu;
